module.exports = __webpack_public_path__ + "static/finite-and-infinite-games-52c69ce59214656aab078a319d49b9b9.jpg";